export function migrateAutoplayABTest() {
  const stored = localStorage.getItem('video-features-storage');
  
  if (stored) {
    try {
      const data = JSON.parse(stored);
      
      // If autoplayOverlay.abTestConfig doesn't have variations array, fix it
      if (data.state?.features?.autoplayOverlay?.abTestConfig) {
        const config = data.state.features.autoplayOverlay.abTestConfig;
        
        if (!Array.isArray(config.variations)) {
          config.variations = [];
          localStorage.setItem('video-features-storage', JSON.stringify(data));
          console.log('✅ Migração de Autoplay A/B Test concluída');
        }
      }
    } catch (e) {
      console.error('Erro ao migrar Autoplay A/B Test:', e);
    }
  }
}
